import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

const t = (key, ...args) => Vuetify.locale.t(key, ...args)

// Per-action snackbar keys: `loading` is a __SnackBar.* key, `success` an __AI.mrc.batch.* key.
const ACTION_SNACKBAR = {
  delete: { loading: 'deleting', success: 'success_delete' },
  enable: { loading: 'updating', success: 'success_enable' },
  disable: { loading: 'updating', success: 'success_disable' }
}

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    action: null, // 'delete' | 'enable' | 'disable'
    ids: [],
    // refresh args handed back to fetchMrcAiScanList once the batch completes
    params: null
  },
  mutations: {
    INIT_MRC_BATCH_ACTION_DIALOG(state, payload) {
      state.visibility = true
      state.action = payload.action
      state.ids = payload.ids
      state.params = payload.params
    },
    SET_MRC_BATCH_ACTION_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_MRC_BATCH_ACTION_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.action = null
        state.ids = []
        state.params = null
      }, 100)
    }
  },
  actions: {
    async confirmMrcBatchAction({ state, commit, dispatch }) {
      const action = state.action
      const ids = [...state.ids]
      try {
        commit('SET_MRC_BATCH_ACTION_DIALOG_SUBMIT_BTN_DISABLE', true)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: t(`$vuetify.__SnackBar.${ACTION_SNACKBAR[action].loading}`, ''), loading: true })

        let response = null
        if (action === 'delete') response = await api.batchDeleteMrcDoc({ params: { ids } })
        else response = await api.batchToggleMrcDocEnable({ params: { ids, enabled: action === 'enable' } })

        const counts = response.data.data || {}
        const success_count = counts.success_count ?? 0
        const fail_count = counts.fail_count ?? 0

        if (fail_count > 0) {
          // Partial (some ok) or total failure — surface the per-id breakdown.
          commit('SET_SNACKBAR', {
            status: true,
            color: success_count > 0 ? 'warning' : 'error',
            text: success_count > 0 ? t('$vuetify.__AI.mrc.batch.partial', success_count, fail_count) : response.data.message,
            icon: success_count > 0 ? 'alert' : 'close',
            timeout: '3000'
          })
        } else {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: t(`$vuetify.__AI.mrc.batch.${ACTION_SNACKBAR[action].success}`, success_count), icon: 'check', timeout: '2000' })
        }

        // Refresh the list (also clears selection) and close the dialog.
        dispatch('fetchMrcAiScanList', state.params)
        commit('RESET_MRC_BATCH_ACTION_DIALOG')
      } catch (error) {
        // Keep the dialog open so the admin can retry; selection is untouched.
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_MRC_BATCH_ACTION_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
